import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getShowChartingOptions } from '@/store-selectors';
import { layerUserInteraction } from '@/actions';
import { QUERY_RESULTS } from '@/components/ChartHolder.constants';
import { EditQuery as EditQueryBase } from '../buttons';
import { useHandlePresentationChange } from './hooks';

export const EditQuery = () => {
  const dispatch = useDispatch();
  const handleChange = useHandlePresentationChange(QUERY_RESULTS as any);
  const areChartingOptionsShown = useSelector(getShowChartingOptions);

  const handleClick = () => {
    handleChange();
    dispatch(
      layerUserInteraction({ event: 'toggle-charting', newValue: false }),
    );
  };

  return (
    <EditQueryBase onClick={handleClick} $active={!areChartingOptionsShown} />
  );
};
